import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import VouchersTaken from '../pages/Voucher/VouchersTaken';
import PackageType from '../pages/PackageType/PackageType';
import ProductPage from '../pages/Product/ProductPage';
import WifiToken from '../pages/Token/WifiToken';
import UserRoleSettings from '../pages/UserSetting/UserRoleSettings';
import UserSettings from '../pages/UserSetting/UserSettings';

// components
import PrivateRoute from './PrivateRoute';
import Root from './Root';

// lazy load all the views

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'));


// dashboard
const EcommerceDashboard = React.lazy(() => import('../pages/dashboard/Ecommerce'));
// extra pages
const Error404 = React.lazy(() => import('../pages/error/Error404'));
const Error500 = React.lazy(() => import('../pages/error/Error500'));

// widgets

export interface RoutesProps {
    path: RouteProps['path'];
    name?: string;
    component?: RouteProps['component'];
    route?: any;
    exact?: RouteProps['exact'];
    icon?: string;
    header?: string;
    roles?: string[];
    children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
    component: () => <Root />,
    route: PrivateRoute,
};

// dashboards
const dashboardRoutes: RoutesProps = {
    path: '/dashboard',
    name: 'Dashboards',
    icon: 'airplay',
    header: 'Navigation',
    component: EcommerceDashboard,
    route: PrivateRoute,
};

const tokenRoutes: RoutesProps = {
    path: '/tokenlist',
    name: 'Wifi Tokens/Vouchers',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'file-text',
    component: WifiToken,
}; 

const productRoutes: RoutesProps = {
    path: '/packagelist',
    name: 'Packages/Products',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'database',
    component: ProductPage,
};

const packageTypeRoutes: RoutesProps = {
    path: '/packagetype',
    name: 'Package/Product Types',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'map',
    component: PackageType,
};

const userListRoutes: RoutesProps = {
    path: '/settings/users',
    name: 'User List',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'users',
    component: UserSettings,
};

const userRoleRoutes: RoutesProps = {
    path: '/settings/userrolelist',
    name: 'User Roles',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'clipboard',
    component: UserRoleSettings,
};

const takenVouchersRoutes: RoutesProps = {
    path: '/customervoucherlist',
    name: 'Customer Vouchers Taken',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'layers',
    component: VouchersTaken,
};

const appRoutes = [
    userRoleRoutes,takenVouchersRoutes,userListRoutes,packageTypeRoutes,productRoutes,tokenRoutes
];  

const authRoutes: RoutesProps[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        route: Route,
    },
    {
        path: '/auth/register',
        name: 'Register',
        component: Register,
        route: Route,
    },
    {
        path: '/auth/confirm',
        name: 'Confirm',
        component: Confirm,
        route: Route,
    },
    {
        path: '/auth/forget-password',
        name: 'Forget Password',
        component: ForgetPassword,
        route: Route,
    },
    {
        path: '/auth/lock-screen',
        name: 'Lock Screen',
        component: LockScreen,
        route: Route,
    },
    {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        route: Route,
    },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
    
    {
        path: '/error-404',
        name: 'Error - 404',
        component: Error404,
        route: Route,
    },
    {
        path: '/error-500',
        name: 'Error - 500',
        component: Error500,
        route: Route,
    },
];
// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes = routes || [];
    routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const authProtectedRoutes = [rootRoute, dashboardRoutes, ...appRoutes, ];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
 